import { Routes, Route, Navigate } from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import ClinicFormPage from "./pages/ClinicForm";

import Dashboard from "./pages/Dashboard";
import Passport from "./pages/Passport";
import Notifications from "./pages/Notifications";
import Report from "./pages/Report";
import Clinics from "./pages/Clinics";
import Analytics from "./pages/Analytics";
import Login from "./pages/Login";

import ProtectedRoute from "./components/ProtectedRoute";

import ChangePassword from "./pages/ChangePassword";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import IncidentsList from "./pages/Incidents/IncidentsList";
import CreateIncident from "./pages/Incidents/CreateIncident";
import IncidentDetails from "./pages/Incidents/IncidentDetails";

import { useEffect } from "react";
import { initIdleLogout } from "./utils/idleLogout";

function App() {

  useEffect(() => {
    initIdleLogout();
  }, []);

  return (
    <>
      <Routes>
        {/* 🔓 LOGIN (публичный) */}
        <Route path="/login" element={<Login />} />

        {/* 🔐 ВСЁ ОСТАЛЬНОЕ ПОД ЗАЩИТОЙ */}
        <Route
          path="/"
          element={
            <ProtectedRoute
              roles={["clinic", "clinic_inspector", "regional_inspector", "central", "admin"]}
            >
              <MainLayout />
            </ProtectedRoute>
          }
        >
          {/* вложенные маршруты */}
          <Route index element={<Dashboard />} />
          <Route path="passport" element={<Passport />} />
          <Route path="passport/:clinicId" element={<Passport />} />
          <Route path="notifications" element={<Notifications />} />
          <Route path="reports" element={<Report />} />
          <Route path="reports/:reportId" element={<Report />} />
          <Route path="clinics" element={<Clinics />} />
          <Route
            path="clinics/create"
            element={<ClinicFormPage />}
          />

          <Route
            path="clinics/:clinicId/edit"
            element={<ClinicFormPage />}
          />
          <Route path="analytics" element={<Analytics />} />

          <Route
            path="change-password"
            element={<ChangePassword />}
          />

          <Route path="incidents" element={<IncidentsList />} />
          <Route path="incidents/create" element={<CreateIncident />} />
          <Route path="incidents/:id" element={<IncidentDetails />} />
        </Route>

        {/* fallback */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>

      {/* 🔔 ToastContainer ДОЛЖЕН быть вне Routes */}
      <ToastContainer position="top-right" autoClose={5000} />
    </>
  );
}
export default App;
